<p-table #dt [columns]="selectedColumns" appendTo='body' [value]="signaletiquesO | async">
    <ng-template pTemplate="caption">
        <div class="ui-helper-clearfix" style="text-align: left">

            <button *ngIf="false" type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL" (click)="exportExcel()"
                style="margin-right: 0.5em;" class="btn-def"></button>
            <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" label="PDF" (click)="exportPdf()"
                class="btn-def"></button>


            <div style="width: 200px;float: right;">
                <p-multiSelect [options]="cols" appendTo='body' [(ngModel)]="selectedColumns" optionLabel="header"
                    selectedItemsLabel="{0} columns selected" [style]="{minWidth: '200px' }"
                    defaultLabel="Choose Columns">
                </p-multiSelect>
            </div>


        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>

        <tr>

            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.width]="col.width">
                {{col.header}}
                <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>


        </tr>
        <tr>
            <th *ngFor="let col of columns" [ngSwitch]="col.field">

                <p-selectButton *ngSwitchCase="'pubSent'" [options]="types"
                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-selectButton>
                <p-selectButton *ngSwitchCase="'signalitiqueSent'" [options]="types"
                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-selectButton>
                <p-selectButton *ngSwitchCase="'viw'" [options]="types"
                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-selectButton>
                <p-selectButton *ngSwitchCase="'viwPlan'" [options]="types"
                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-selectButton>

                <input *ngSwitchDefault style="width:100% ;" style="border: none;" type="text"
                    (input)="dt.filter($event.target.value, col.field, 'contains')">


            </th>


        </tr>

    </ng-template>
    <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">

            <td *ngFor="let col of columns" [ngSwitch]="col.field">

                <div *ngSwitchCase="'logo'"> <img *ngIf="false" width="50"
                        src="http://floorplan.napec-dz.com/ExhibitorsData/{{rowData.pavillion}}/Logo/{{rowData.pavillion}}logo.png"
                        onerror="this.src = 'http://floorplan.napec-dz.com/images/PhotoND2.png'">
                </div>
                <div *ngSwitchCase="'pub'">

                    <img width="50" *ngIf="false"
                        src="http://floorplan.napec-dz.com/ExhibitorsData/{{rowData.pavillion}}/pub/{{rowData.pavillion}}pub.png"
                        onerror="this.src = 'http://floorplan.napec-dz.com/images/PhotoND2.png'">
                </div>





                <span *ngSwitchCase="'pubSent'"> <span *ngIf="rowData.pubSent">Oui</span>
                    <span *ngIf="!rowData.pubSent">Non</span> </span>
                <span *ngSwitchCase="'signalitiqueSent'"><span *ngIf="rowData.signalitiqueSent">Oui</span> <span
                        *ngIf="!rowData.signalitiqueSent">Non</span></span>
                <span *ngSwitchCase="'viw'"><span *ngIf="rowData.viw">Oui</span> <span *ngIf="!rowData.viw">Non</span>

                </span>
                <span *ngSwitchCase="'viwPlan'"><span *ngIf="rowData.viwPlan">Oui</span> <span
                        *ngIf="!rowData.viwPlan">Non</span></span>




                <div *ngSwitchDefault>{{rowData[col.field]}}</div>

            </td>


        </tr>
    </ng-template>
</p-table>